<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12xFVqk/tc-custom/9781250127532.jpg?1737763721516" alt="This image is the cover for the book The Comedown"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Comedown
      </h1>
      <p class="bookDescription body article font2">
        <b>“So good, so fully realized. . . . A book about how easily our lives are wrecked, but also how powerfully we’re able to survive and rebuild.” —Nathan Hill, <i>The New York Times Book Review</i></b><br/><br/>A blistering dark comedy, Rafael Frumkin’s <i>The Comedown</i> is a romp across America, from the Kent State shootings to protest marches in Chicago to the Florida Everglades, that explores delineating lines of race, class, religion, and time.<br/><br/>Scrappy, street smart drug dealer Reggie Marshall has never liked the simpering addict Leland Bloom-Mittwoch, which doesn’t stop Leland from looking up to Reggie with puppy-esque devotion. But when a drug deal goes dramatically, tragically wrong and a suitcase (which may or may not contain a quarter of a million dollars) disappears, the two men and their families become hopelessly entangled. It’s a mistake that sets in motion a series of events that are odd, captivating, suspenseful, and ultimately inevitable.<br/><br/>Both incendiary and earnest, <i>The Comedown</i> steadfastly catalogs the tangled messes the characters make of their lives, never losing sight of the beauty and power of each family member’s capacity for love, be it for money, drugs, or each other.<br/><br/>“A resounding success.” —<i>The L.A. Review of Books</i><br/><br/>“Ambitious, exhilarating . . . so compelling that, even when the novel concludes, the reader is left wondering where their lives took them.” —<i>The Columbus Dispatch</i><br/><br/>“An engrossing read. . . . Frumkin is whip-smart and funny.” —<i>The Millions</i><br/><br/>“Frumkin’s debut may find itself sharing shelf space with Franzen and Chabon.” —<i>Full Stop</i><br/><br/>“Frumkin has talent to burn.” —<i>Kirkus Reviews</i>, starred review<br/><br/>“Vivid and compassionately drawn characters.” —<i>Library Journal</i> (starred)<br/><br/>“Funny, heartbreaking. . . . Frumkin’s intelligence and empathy radiates off every page.” —Carmen Maria Machado, author of <i>Her Body and Other Parties</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rafael Frumkin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4957acaa